var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"component-mobile-app-link",attrs:{"href":_vm.specificData.href,"target":"_blank"}},[_c('img',{staticClass:"component-mobile-app-link-image",attrs:{"src":_vm.specificData.image.url,"alt":_vm.specificData.image.filename}})])
}
var staticRenderFns = []

export { render, staticRenderFns }